module.exports = __webpack_public_path__ + "media/dogs/dog-with-bag--sprite-00955f96.svg";